import { formatDate } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { EditorBookingItemSettingBookingDate } from '../editor-booking-item-setting/editor-booking-item-setting-booking-date.model';


@Component({
    selector: 'eas-editor-booking-item-setting-value-booking-date',
    templateUrl: './editor-booking-item-setting-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingValueBookingDateComponent implements OnChanges, OnInit {
  @Input() itemSetting: EditorBookingItemSettingBookingDate;

  value: string;

  constructor(@Inject(LOCALE_ID) private locale: string) {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      this.value = this.getValue();
    }
  }

  getValue(): string {
    const formattedStart = this.itemSetting.start === null ? null : formatDate(this.itemSetting.start.toDate(), 'short', this.locale);
    const formattedDateStart = this.itemSetting.start === null ? null : formatDate(this.itemSetting.start.toDate(), 'shortDate', this.locale);
    const formattedTimeStart = this.itemSetting.start === null ? null : formatDate(this.itemSetting.start.toDate(), 'shortTime', this.locale);
    const formattedEnd = this.itemSetting.end === null ? null : formatDate(this.itemSetting.end.toDate(), 'short', this.locale);
    const formattedDateEnd = this.itemSetting.end === null ? null : formatDate(this.itemSetting.end.toDate(), 'shortDate', this.locale);
    const formattedTimeEnd = this.itemSetting.end === null ? null : formatDate(this.itemSetting.end.toDate(), 'shortTime', this.locale);

    let summary: string;
    if (this.itemSetting.start !== null && this.itemSetting.end !== null) {
      summary = (formattedDateStart === formattedDateEnd)
        ? $localize `${formattedDateStart}, ${formattedTimeStart} to ${formattedTimeEnd}`
        : $localize `${formattedStart} to ${formattedEnd}`;
    } else if (this.itemSetting.start !== null) {
      summary = $localize `${formattedStart} to ...`;
    } else if (this.itemSetting.end) {
      summary = $localize `... to ${formattedEnd}`;
    }

    if (summary === undefined) {
      return '';
    }

    if (this.itemSetting.timezone !== null) {
      summary = `${summary} ${this.itemSetting.timezone}`;
    }

    return summary;
  }
}
